import { DefaultService } from '@/services/DefaultService';

export default class FormFormularioService extends DefaultService {

    constructor(http, router, env) {
        super(http, router, env);
    }

    save(formulario, contexto = "pro") {
        return this._http.post(`${this._env}/${contexto}/formFormulario`, formulario, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    find(id, contexto = "pro") {
        return this._http.get(`${this._env}/${contexto}/formFormulario/completo/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    delete(id, contexto = "pro") {
        return this._http.delete(`${this._env}/${contexto}/formFormulario/${id}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findAll(column, order, page = 0, limit = 50, situacao = 2, contexto = "pro", ...params) {
        return this._http.get(encodeURI(`${this._env}/${contexto}/formFormulario.json?column=${column}&order=${order}&page=${page}&limit=${limit}&situacao=${situacao}&contexto=${contexto}&param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findAllFormPreenchimento(column, order, page = 0, limit = 50, idTabelaFrom, geralTabela, uuidTabelaFrom, formRespostaCabecalhoGeralTabela, ...params) {
        return this._http.get(encodeURI(`${this._env}/ven/formPreenchimento/formFormulario.json?column=${column}&order=${order}&page=${page}&limit=${limit}&idTabelaFrom=${idTabelaFrom}&formFormularioGeralTabela=${geralTabela}&uuidTabelaFrom=${uuidTabelaFrom}&formRespostaCabecalhoGeralTabela=${formRespostaCabecalhoGeralTabela}&param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findAllCombo(situacao = 1, limit, contexto = "pro", ...params) {
        return this._http.get(encodeURI(`${this._env}/${contexto}/getcombo/formFormulario.json?situacao=${situacao}&limit=${limit}&contexto=${contexto}&param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    updateSituacao(formulario, contexto = "pro") {
        return this._http.post(`${this._env}/${contexto}/formFormulario/updatesituacao`, formulario, this._headers).then(res => {
                return res.body;
        }, err => {
                this.verifyError(err);
                throw new Error("Problems while jobs are loading");
        });
    }

    findAssFormGeralByUuid(uuidFormFormulario, uuidFormRespostaCabecalho) {
        return this._http.get(`${this._env}/ven/formPreenchimento.json?uuidFormFormulario=${uuidFormFormulario}&uuidFormRespostaCabecalho=${uuidFormRespostaCabecalho}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

}